export default __webpack_public_path__ + "media/stress-glp1-companion.c1942951adcb4808caaffaaa314241f2.webp";